import BybVrSlider from "@Components/game/common/dialog/byb-vr-slider";
import { Stack, Typography } from "@mui/material";

interface IMatchPlaySettingSlider {
  disabled?: boolean;
  label: string;
  max: number;
  min: number;
  onChange: (event: Event, newValue: number | number[]) => void;
  marks?: boolean | Array<{ value: number; label?: string }>;
  step?: number | null;
  value: number;
  valueLabel: string;
}

const MatchPlaySettingSlider = ({ disabled, label, marks = true, max, min, onChange, step, value, valueLabel }: IMatchPlaySettingSlider) => {
  return (
    <Stack spacing={1.5}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="textLg500" color="dsNeutral.v300">
          {label}
        </Typography>
        <Typography variant="textLg500" color="dsBase.v200">
          {valueLabel}
        </Typography>
      </Stack>
      <BybVrSlider value={value} onChange={onChange} step={step} marks={marks} min={min} max={max} disabled={disabled} />
    </Stack>
  );
};

export default MatchPlaySettingSlider;
